export default interface FoodOption {
  readonly id?: number;
  readonly breakfast?: boolean;
  readonly lunch?: boolean;
  readonly snack?: boolean;
}

export const FoodOptionInital: FoodOption = {
  breakfast: false,
  lunch: false,
  snack: false
};
